import { render } from "./RenewRecord.vue?vue&type=template&id=81d56692&scoped=true"
import script from "./RenewRecord.vue?vue&type=script&lang=js"
export * from "./RenewRecord.vue?vue&type=script&lang=js"

import "./RenewRecord.vue?vue&type=style&index=0&id=81d56692&lang=scss&scoped=true"
import "./RenewRecord.vue?vue&type=style&index=1&id=81d56692&lang=css"
script.render = render
script.__scopeId = "data-v-81d56692"

export default script